"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenIFrame = exports.ElementResizeListener = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ElementResizeListener = exports.ElementResizeListener = _styledComponents["default"].div.withConfig({
  displayName: "styles__ElementResizeListener",
  componentId: "sc-ukl416-0"
})(["position:", ";"], function (p) {
  return p.position;
});
var HiddenIFrame = exports.HiddenIFrame = _styledComponents["default"].iframe.withConfig({
  displayName: "styles__HiddenIFrame",
  componentId: "sc-ukl416-1"
})(["position:absolute;visibility:hidden;&,&[style]{border:inherit !important;box-sizing:content-box !important;height:100% !important;width:100% !important;}"]);
//# sourceMappingURL=styles.js.map